import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
//import Snowfall from "../components/Snowfall";
//import MusicToggle from "../components/MusicToggle";


// TODO: Migrar header móvil a React cuando se actualice a React 18

 
class MainLayout extends Component {
  render() {
    return (
      <>
        <Header />
        {/*<Snowfall />
        <MusicToggle />*/}
        
        <motion.main
          className="main-content"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
        >
          {this.props.children}
        </motion.main>

        <Footer />
      </>
    );
  }
}

export default MainLayout;
